// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__Mn5WQ","header":"MessagesList_header__3efJq","chat":"MessagesList_chat__XBlJm"};